import styled from 'styled-components';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
var CheckboxGroup = styled.div.withConfig({
  displayName: "CheckboxGroupstyles__CheckboxGroup",
  componentId: "sc-3un6h3-0"
})(["display:flex;.", "-checkboxgroup__column{display:flex;flex-direction:column;align-items:flex-start;flex:1;}.", "-checkbox.", "-checkboxgroup__checkbox{margin:0 0 ", ";}"], prefix, prefix, prefix, rem(16));
export var Styled = {
  CheckboxGroup: CheckboxGroup
};